import { useApp, useAppRole } from '@hb/react'
import { UserGroup } from '@hb/shared'
import { useMemo } from 'react'

export const useAppGroup = (): UserGroup => {
  const { appName } = useApp()
  const role = useAppRole()
  return useMemo(() => {
    if (role === 'user') return 'patient'
    return appName === 'app' ? 'admin' : 'practice'
  }, [appName, role])
}
